import { Row, Col } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';

import "./Accomodation.css"

function Accomodation() {
    const hotelCampanileUrl = "https://wroclaw-centrum.campanile.com/pl/"
    const hotelNovotelUrl = "https://all.accor.com/hotel/0528/index.pl.shtml";
    const hotelIbisUrl = "https://all.accor.com/hotel/6603/index.pl.shtml";
    const hotelInviteUrl = "https://www.hotelinvite.com.pl";

    return (
        <>
            <Row className="g-4">
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card className="hotelInfo h-100 d-flex flex-column overflow-hidden">
                        <Card.Body>
                            <Card.Img
                                src={`${process.env.PUBLIC_URL}/images/hotel_campanile.jpg`}
                                onClick={() => window.open(hotelCampanileUrl, "_blank")}
                                className="hotelImage"
                            />
                            <Card.Title className="hotelTitle">
                                <a href={hotelCampanileUrl} target="_blank">CAMPANILE WROCLAW CENTRUM</a>
                            </Card.Title>
                            <hr />
                            <Card.Text className="hotelAddress">
                                <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/G6mSK22eyvmbfcJA8" target="_blank">ul. Ślężna 26, 53-302 Wrocław, Polska</a>
                            </Card.Text>
                            <hr />
                            <div>
                                Dla uczestników konferencji hotel udziela:
                                <ul>
                                    <li><b>20%-25%</b> rabatu od ceny regularnej - do <u>31 marca 2026</u> roku</li>
                                </ul>
                            </div>
                            <Card.Text><i>Podczas dokonywania rezerwacji należy podać kod rabatowy: <b>PRZEŁYCZEK</b>.</i></Card.Text>
                            <div>
                                <i className="bi bi-info-circle-fill"></i> Zniżka obowiązuje tylko w przypadku rezerwacji:
                                <ul>
                                    <li>
                                        Mailowej: <a href="mailto:conf.wroclaw.centrum@campanile.com">conf.wroclaw.centrum@campanile.com</a>
                                        <br/><i>W tytule bądź treści maila podać hasło <b>"PRZEŁYCZEK"</b> i wybierać hotel (Premiere Classe/ Campanile Wrocław Centrum)</i>
                                    </li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card className="hotelInfo h-100 d-flex flex-column overflow-hidden">
                        <Card.Body>
                            <Card.Img
                                src={`${process.env.PUBLIC_URL}/images/hotel_novotel.jpg`}
                                onClick={() => window.open(hotelNovotelUrl, "_blank")}
                                className="hotelImage"
                            />
                            <Card.Title className="hotelTitle">
                                <a href={hotelNovotelUrl} target="_blank">Novotel Wrocław City</a>
                            </Card.Title>
                            <hr />
                            <Card.Text className="hotelAddress">
                                <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/nPeQFvvaCCupYXCd8" target="_blank">ul. Wyścigowa 35, 53-011 Wrocław, Polska</a>
                            </Card.Text>
                            <hr />
                            <div>
                                Dla uczestników konferencji hotel udziela:
                                <ul>
                                    <li><b>20%</b> rabatu od ceny regularnej - do <u>31 marca 2026</u> roku</li>
                                    <li><b>10%</b> rabatu od ceny regularnej - od <u>1 kwietnia</u> do <u>30 kwietnia 2026</u> roku</li>
                                </ul>
                            </div>
                            <Card.Text><i>Podczas dokonywania rezerwacji należy podać kod rabatowy: <b>PRZEŁYCZEK</b>.</i></Card.Text>
                            <div>
                                <i className="bi bi-info-circle-fill"></i> Zniżka obowiązuje tylko w przypadku rezerwacji:
                                <ul>
                                    <li>Telefonicznej: <a href="tel:+48713398051">+48 71 339 80 51</a></li>
                                    <li>Mailowej: <a href="mailto:H0582-RE@ACCOR.COM">H0582-RE@ACCOR.COM</a></li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card className="hotelInfo h-100 d-flex flex-column overflow-hidden">
                        <Card.Body>
                            <Card.Img
                                src={`${process.env.PUBLIC_URL}/images/hotel_ibis.jpg`}
                                onClick={() => window.open(hotelIbisUrl, "_blank")}
                                className="hotelImage"
                            />
                            <Card.Title className="hotelTitle">
                                <a href={hotelIbisUrl} target="_blank">ibis Budget Wrocław Południe</a>
                            </Card.Title>
                            <hr />
                            <Card.Text className="hotelAddress">
                                <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/BsNiqCmRPpTfep9TA" target="_blank">ul. Wyścigowa 35A, 53011 Wrocław, Polska</a>
                            </Card.Text>
                            <hr />
                            <div>
                                Dla uczestników konferencji hotel udziela:
                                <ul>
                                    <li><b>10%</b> rabatu od ceny regularnej - do <u>30 kwietnia 2026</u> roku</li>
                                </ul>
                            </div>
                            <Card.Text><i>Podczas dokonywania rezerwacji należy podać kod rabatowy: <b>PRZEŁYCZEK</b>.</i></Card.Text>
                            <div>
                                <i className="bi bi-info-circle-fill"></i> Zniżka obowiązuje tylko w przypadku rezerwacji:
                                <ul>
                                    <li>Telefonicznej: <a href="tel:+48713398051">+48 71 339 80 51</a></li>
                                    <li>Mailowej: <a href="mailto:H0528-RE@ACCOR.COM">H0528-RE@ACCOR.COM</a></li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card className="hotelInfo h-100 d-flex flex-column overflow-hidden">
                        <Card.Body>
                            <Card.Img
                                src={`${process.env.PUBLIC_URL}/images/hotel_invite.jpg`}
                                onClick={() => window.open(hotelInviteUrl, "_blank")}
                                className="hotelImage"
                            />
                            <Card.Title className="hotelTitle">
                                <a href={hotelInviteUrl} target="_blank">Hotel InVite</a>
                            </Card.Title>
                            <hr />
                            <Card.Text className="hotelAddress">
                                <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/V5JaqtYqj4Gwmev36" target="_blank">ul. Hubska 54, 50-502 Wrocław, Polska</a>
                            </Card.Text>
                            <hr />
                            <div>
                                Dla uczestników konferencji hotel udziela:
                                <ul>
                                    <li><b>20%</b> rabatu od ceny regularnej - na rezerwacje  w dniach <u>7-11 maja 2026</u> roku</li>
                                </ul>
                            </div>
                            <Card.Text><i>Podczas dokonywania rezerwacji należy podać kod rabatowy: <b>PRZEŁYCZEK</b>.</i></Card.Text>
                            <div>
                                <i className="bi bi-info-circle-fill"></i> Zniżka obowiązuje tylko w przypadku rezerwacji:
                                <ul>
                                    <li>Mailowej: <a href="mailto:groups@hotelinvite.pl">groups@hotelinvite.pl</a></li>
                                    <li>Telefonicznej: <a href="tel:+48889208347">+48 889 208 347</a></li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default Accomodation;